import CheckoutPage from './page'
import CheckoutTemplate from './template'

export {
  CheckoutTemplate
}

export default CheckoutPage
